import { createRef, Component } from 'react';
import '../../App.css';
import AuthenticationContext from '../../Authentication/types/AuthContextType';
import { withTranslation } from 'react-i18next';
import SitesHttpClient from '../../HttpClient/SitesHttpClient';
import ChartHttpClient from '../../HttpClient/ChartHttpClient';
import SiteTabs from '../SitesComponents/Main/SiteTabs';
import InstallationsSummaryEdit from '../InstallationComponents/Main/InstallationsSummaryEdit';
import BreadCrumb from '../BreadCrumb';
import Error from '../Error';
import Message from '../Message/Message';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { withRouter } from '../withRouter';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import playIcon from '../../assets/icons/play.svg';

export class Site extends Component {
  static contextType = AuthenticationContext;
  constructor(props) {
    super(props);
    this.refreshButtonRef = createRef();
    this.imgRefreshButtonRef = createRef();
    this.state = {
      language: this.props.i18n.language,
      _site: null,
      _chartViewZones: null,
      groupBySelected: 'day',
      dateRange: null,
      calOpened: false,
      multi: false,
      errors: null,
      show: false,
      message: null,
      tabSelected: 0,
    };
    this.dateRange = null;
    this.groupBy = 'day';
    if (
      (this.props.match != undefined && this.props.match.params.id != undefined) ||
      this.props.location.pathname.split('/').length > 1
    )
      this.id =
        this.props.match.params.id == undefined
          ? parseInt(this.props.location.pathname.split('/')[2])
          : this.props.match.params.id;

    this.dateRange = this.getCurrentDateRange();
    this.groupBy = this.getCurrentGroupBy();
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });

    localStorage.setItem('CurrentDateRange', null);
    localStorage.setItem('CurrentGroupBy', 'day');

    this.dateRange = null;
    this.groupBy = 'day';

    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if(this.state.language !== this.props.i18n.language){
      this.loadData();
      this.setState({ language: this.props.i18n.language });
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ errors: null });
      var idSite = parseInt(this.props.location.pathname.split('/')[2]);
      if (idSite != this.id) {
        this.id = idSite;
        this.loadData();
        this.dateRange = this.getCurrentDateRange();
        this.groupBy = this.getCurrentGroupBy();
      }
    }
  }
  handleTabSelected = (index) => {
    if (typeof index === 'number' && index !== this.state.tabSelected) {
      this.setState({tabSelected: index, updateCountdown: false, activeAnimation: false});  
    }
  }
  renderMessage = (type, content) => {
    this.setState({
      message: {
        type: type,
        content: content,
      },
    });
  };

  handleDialogClose = () => {
    this.setState({ message: null });
  };

  loadData() {
    this.getSiteInfo();
    this.getChartViewZones();
  }
  async getChartViewZones() {
    this.httpChart = new ChartHttpClient(this.context, null, null);
    var chartViewZones = await this.httpChart.SitesGetChartViewZones();
    if (chartViewZones !== undefined && chartViewZones.status == 200) this.setState({ _chartViewZones: chartViewZones.data });
  }

  notInstallation = (data) => {
    return data.data && data.data.content && !data.data.content.parentId;
  };

  hasAccess = (data) => {
    return data.data && data.data.content && (data.data.content.hasAccess || data.data.content.hasOwnerAccess);
  };

  async getSiteInfo() {
    try {
      this.http = new SitesHttpClient(this.context, this.id);
      let data = await this.http.GetSite();
      if (data && data.status == 200 && this.hasAccess(data) && this.notInstallation(data)) {
        this.setState({ _site: data.data.content, dateRange: this.dateRange, groupBySelected: this.groupBy, errors: null });
        if (data.errors != null) {
          this.setState({ errors: data.errors });
        }
      } else {
        if (data.status == 401) {
          this.setState({ errors: 'Unauthorized' });
        } else {
          this.setState({
            errors:
              data.data && data.data.content && data.data.content.parentId
                ? 'parentId error'
                : data.data
                ? data.data
                : data.status,
          });
        }
      }
    } catch (err) {
      if (!this.state.errors) {
        this.setState({ errors: err });
      }
    }
  }

  handleClick() {
    this.setState({ show: !this.state.show });
  }

  showSelector(show) {
    try {
      let buttons = document.getElementsByClassName('configButton');

      for (let btn of buttons) {
        if (btn.classList.contains('d-none')) {
          if (show) btn.classList.remove('d-none');
        } else if (!show) {
          btn.classList.add('d-none');
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  onChangeDate(value, groupBy) {
    this.dateRange = value;
    this.groupBy = groupBy;
  }

  getCurrentDateRange() {
    var currentDateRange = null;
    try {
      currentDateRange = JSON.parse(localStorage.getItem('CurrentDateRange')) || null;
    } catch (e) {
      currentDateRange = null;
    }
    return currentDateRange;
  }
  getCurrentGroupBy() {
    var currentGroupBy = 'day';
    try {
      currentGroupBy = JSON.parse(localStorage.getItem('CurrentGroupBy')) || 'day';
    } catch (e) {
      currentGroupBy = 'day';
    }
    return currentGroupBy;
  }

  render() {
    const { t } = this.props;

    const handleHomeIcon = (event) => {
      // this.setState({ groupBySelected: "week", dateRange: [moment().add(-6, 'd').toDate(), new Date()] })
      //this.setState({ groupBySelected: "week" })
      this.loadData();
      this.setState({ groupBySelected: this.groupBy, dateRange: this.dateRange });
    };

    const scrollToTop = (event) => {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    const handleClose = (res) => {
      this.setState({ show: false, refreshAllComponents: true });
      if (res && res.id) {
        this.renderMessage('success', t('actions.success'));
        setTimeout(() => {
          this.getSiteInfo();
        }, 1600);
      }
    };
    let top = '';
    let titulo = '';
    const onRefresh = () => {
      this.setState({ refreshAllComponents: false, groupBySelected: this.groupBy, dateRange: this.dateRange });
    };
    let dataLoaded = this.state._chartViewZones != null && this.state._site != null;
    let editmodecomponent, boton;

    if (this.state.show) {
      titulo = t('actions.editname', { name: t('site') });
      editmodecomponent = (
        <InstallationsSummaryEdit
          type='site'
          createSite={false}
          installation={this.state._site}
          onSaveClose={handleClose}
          id={this.id}
          mode='edit'
          showdelete={true}
        ></InstallationsSummaryEdit>
      );
    }

    const managePage = (errors) => {
      if (!errors) {
        return (
          <div className='row loadingParent'>
            <div className='loadingImg'></div>
          </div>
        );
      } else if (errors === 'parentId error') {
        return <Error errors={{ status: 404 }} error={'Site not found'} />;
      } else if (errors === 'Unauthorized') {
        return <Error errors={{ status: 401 }} error={errors} />;
      } else {
        return <Error errors={errors} />;
      }
    };

    return (
      <div id='rootElement'>
        {this.state.message && <Message {...this.state.message} onClose={this.handleDialogClose} />}
        {dataLoaded && this.state.errors == null ? (
          <div id='parentElementIsTop'>
            <Dialog classes={{ paper: 'installationModal' }} disableEscapeKeyDown open={this.state.show} onClose={handleClose}>
              <DialogActions className='jc-spaceBetween'>
                <h2 className='mb-0 ml-4'>{titulo}</h2>
                <IconButton onClick={handleClose}>
                  <CloseIcon fontSize='large' />
                </IconButton>
              </DialogActions>
              <DialogContent>{editmodecomponent}</DialogContent>
            </Dialog>
            <BreadCrumb level='sites' doubleSticky={true}></BreadCrumb>

            <div style={{ margin: '10px 0px', position: 'relative' }}>
              <div className='granularityParent'>
                {this.state.tabSelected === 3 ?  
                    <div ref={this.refreshButtonRef}
                    id="refresh-button-RTM-table"
                    className="buttonScroll resset refresh-btn-class RTM" >
                    <span>
                        <span className="t2">
                          <img ref={this.imgRefreshButtonRef}
                            id="refresh-icon"
                            alt="Resset"
                            style={{ width: "24px" }}
                            src={playIcon}  />
                        </span>
                    </span>
                  </div> :
                  <div className='buttonScroll resset' onClick={handleHomeIcon}>
                    <span>
                      <span className='t2'>
                        <img
                          alt='Resset'
                          style={{ width: '24px' }}
                          src='https://strgpiotcoredev.blob.core.windows.net/pictos-by-product/11_arrow-clockwise.svg'
                        />
                      </span>
                    </span>
                  </div>
                }
                <div className='buttonScroll backToTop'>
                  <span>
                    <span onClick={scrollToTop} className='t2'>
                      <img
                        alt='Back to Top'
                        style={{ width: '24px' }}
                        src='https://strgpiotcoredev.blob.core.windows.net/pictos-by-product/11_chevron_up.svg'
                      />
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <SiteTabs
                showSelector={this.showSelector}
                data={this.state._site}
                groupBySelected={this.state.groupBySelected}
                dateRange={this.state.dateRange}
                chartViewZones={this.state._chartViewZones}
                refreshAllComponents={this.state.refreshAllComponents}
                handleClick={this.handleClick.bind(this)}
                onRefresh={onRefresh}
                onChangeDate={this.onChangeDate.bind(this)}
                handleTabSelected={this.handleTabSelected}
                refreshButtonRef={this.refreshButtonRef}
                imgRefreshButtonRef={this.imgRefreshButtonRef}
              />
            </div>
          </div>
        ) : (
          managePage(this.state.errors)
        )}
      </div>
    );
  }
}

export default withTranslation()(withRouter(Site, [{ path: '/site/:id' }]));
